if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        //console.log(this.form);
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        //if (document.querySelector('cart-drawer'))  //this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        const formID = this.form.getAttribute('id');
        evt.preventDefault();

        function validateInputs() {
          let required = true;
          document
            .querySelectorAll(`input[form="${formID}"]`)
            .forEach((input) => {
              //  console.log(input);
              if (input.reportValidity() == false) {
                required = false;
                return false;
              }
            });
          return required;
        }

        //console.log(validateInputs());

        if (validateInputs()) {
          if (this.submitButton.getAttribute('aria-disabled') === 'true')
            return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading-overlay__spinner').classList.remove(
            'hidden'
          );

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
                addedToCart(); // KLAVIYO ADD TO CART FUNCTION IN THEME.LIQUID
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty'))
                this.cart.classList.remove('is-empty');
              if (!this.error)
                this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden'
              );
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        console.log(this.errorMessageWrapper, 'WRAPPER ERROR');
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}



 
    
  customElements.define('express-checkout', class extends HTMLElement {
    constructor() {
      super();
      this.checkoutLink = this.querySelector('[data-direct-checkout]');
      if (!this.checkoutLink) return;

      this.checkoutLink.addEventListener('click', this.handleCheckout.bind(this));
    }

    async handleCheckout(event) {
      event.preventDefault(); // ✅ Prevent default anchor behavior immediately
      console.log(event, ' Direct Checkout Event');

      const formId = this.checkoutLink.getAttribute('data-form');
      const form = document.getElementById(formId);
      if (!form) {
        console.warn(`Form with ID "${formId}" not found`);
        return;
      }

      const qtyInput = form.querySelector('.quantity__input');
      const variantInput = form.querySelector('[name="id"]');

      const quantity = parseInt(qtyInput?.value, 10) || 1;
      const variantId = variantInput?.value?.trim();

      if (!variantId) {
        alert('Variant ID is missing');
        return;
      }

      try {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [{ id: variantId, quantity }]
    })
  });

  const result = await response.json();

  if (result.status === 'error') {
    alert(result.message || 'Error adding to cart');
    return;
  }
const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();
  console.log('🛒 Cart contents:', cart);
  // ✅ Only redirect after successful add
   window.location.href = '/checkout';
} catch (err) {
  console.error('Cart add failed:', err);
  alert('Something went wrong. Please try again.');
}
    }
  }); 